import { render, staticRenderFns } from "./ViewProjectContainer.vue?vue&type=template&id=2a2eefe4&scoped=true&"
import script from "./ViewProjectContainer.vue?vue&type=script&lang=js&"
export * from "./ViewProjectContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2eefe4",
  null
  
)

export default component.exports